import { PayloadAction } from '../../../store.model';
import { ActionType } from '../focus-selector.action';
import { FocusSelectorState } from '../focus-selector.state';
import { reusableGridSort } from '../grid/reusable-grid.function';

import { FocusSelectorSortFocuses } from './focus-selection-sort.action';

export function focusSelectorSortFocusesReducer(
    state: FocusSelectorState,
    action: PayloadAction<ActionType, FocusSelectorSortFocuses>,
): FocusSelectorState {
    const { column } = action.payload;
    const { sortDefs, defaultSortDefs } = state.focusSelectionGrid;
    const nextSortDefs = reusableGridSort(column, sortDefs, defaultSortDefs);

    return {
        ...state,

        focusSelectionGrid: {
            ...state.focusSelectionGrid,
            sortDefs: nextSortDefs,
        },
    };
}
